module.exports = __webpack_public_path__ + "static/media/SanadNew.fc3caa6f.svg";